import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { toast } from "sonner";
import { tryCatch } from "@/zapi-frontend/shared/lib/tryCatch";
import { TProjectTemplate } from "./types";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

export function useProjectTemplates(language?: string) {
  const role = useMeStore((s) => s.role);
  const currentOrganizationId = useOrganizationStore((s) => s.currentOrganizationId);

  const { data, isPending } = useQuery({
    queryKey: ["project-templates", currentOrganizationId, language ?? null],
    queryFn: async () => {
      const [response, error] = await tryCatch(
        $api.get<{ data: TProjectTemplate[] }>("/project-templates", {
          params: language ? { language } : undefined,
        })
      );
      if (error) {
        toast.error(error.message);
        throw error;
      }
      return response.data.data;
    },
    enabled: !!role,
  });

  return {
    projectTemplates: data ?? [],
    isProjectTemplatesLoading: isPending,
  };
}
